var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1825.15 1005.11",
    style: {
      enableBackground: "new 0 0 1825.15 1005.11"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:none;stroke:#C05C9F;}\n\t.st2{font-family:'Impact';}\n\t.st3{font-size:248px;}\n\t.st4{display:inline;fill:#C05C9F;}\n\t.st5{font-size:249px;}\n\t.st6{font-size:251px;}\n\t.st7{display:inline;fill:none;stroke:#C05C9F;stroke-miterlimit:10;}\n\t.st8{fill:#C05C9F;}\n\t.st9{fill:none;stroke:#C05C9F;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 980.2886 308.0594)",
    className: "st1 st2 st3 t1"
  }, "STYLES"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 980.2886 600.0594)",
    className: "st4 st2 st3 t2"
  }, "STYLES"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 980.2886 890.0594)",
    className: "st1 st2 st3 t3"
  }, "STYLES"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 599.8936 309.0594)",
    className: "st1 st2 st5 t4"
  }, "THE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 599.8936 601.0594)",
    className: "st1 st2 st5 t5"
  }, "THE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 599.8936 891.0594)",
    className: "st4 st2 st5 t6"
  }, "THE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.9366 311.0594)",
    className: "st4 st2 st6 t7"
  }, "LINK"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.9366 603.0594)",
    className: "st1 st2 st6 t8"
  }, "LINK"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.9366 893.0594)",
    className: "st1 st2 st6 t9"
  }, "LINK"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 980.2886 308.0594)",
    className: "st1 st2 st3 t10"
  }, "STYLES"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 980.2886 600.0594)",
    className: "st7 st2 st3 t11"
  }, "STYLES"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 980.2886 890.0594)",
    className: "st4 st2 st3 t12"
  }, "STYLES"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 599.8936 309.0594)",
    className: "st4 st2 st5 t13"
  }, "THE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 599.8936 601.0594)",
    className: "st1 st2 st5 t14"
  }, "THE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 599.8936 891.0594)",
    className: "st7 st2 st5 t15"
  }, "THE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.9366 311.0594)",
    className: "st7 st2 st6 t16"
  }, "LINK"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.9366 603.0594)",
    className: "st4 st2 st6 t17"
  }, "LINK"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.9366 893.0594)",
    className: "st1 st2 st6 t18"
  }, "LINK"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 980.2886 308.0594)",
    className: "st8 st2 st3 t19"
  }, "STYLES"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 980.2886 600.0594)",
    className: "st9 st2 st3 t20"
  }, "STYLES"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 980.2886 890.0594)",
    className: "st9 st2 st3 t21"
  }, "STYLES"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 599.8936 309.0594)",
    className: "st9 st2 st5 t22"
  }, "THE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 599.8936 601.0594)",
    className: "st8 st2 st5 t23"
  }, "THE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 599.8936 891.0594)",
    className: "st9 st2 st5 t24"
  }, "THE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.9366 311.0594)",
    className: "st9 st2 st6 t25"
  }, "LINK"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.9366 603.0594)",
    className: "st9 st2 st6 t26"
  }, "LINK"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.9366 893.0594)",
    className: "st8 st2 st6 t27"
  }, "LINK"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.2f885ac98d8b3c2dcf5e623ad096cd5a.svg";
export { ForwardRef as ReactComponent };